import type { ITrafficShareBarProps } from "../../../../styled components/StyledTrafficShare/src/StyledTrafficShare";
import { Legend } from "../../../Legends/src/LegendBase/Legend";

import {
    TooltipContainer,
    TooltipTitle,
    TooltipBodyItemContainer,
    SiteShare,
    TooltipItemContainer,
} from "./StyledComponents";

const RenderTooltipTitleIfNeeded = ({ title }: { title?: string }) =>
    title ? <TooltipTitle>{title}</TooltipTitle> : null;

const RenderSubTitleIfNeeded = ({ subTitles }: { subTitles?: string[] }) => {
    const shouldRenderSubTitles = subTitles && subTitles.length > 0;
    return shouldRenderSubTitles ? (
        <TooltipItemContainer>
            <>
                {subTitles.map((subTitle) => {
                    return <div key={subTitle}>{subTitle}</div>;
                })}
            </>
        </TooltipItemContainer>
    ) : null;
};

const RenderTooltipBody = ({ tooltipBodyItems }: { tooltipBodyItems: ITrafficShareBarProps[] }) => {
    return (
        <>
            {tooltipBodyItems.map((tooltipBodyItem) => {
                const shouldRenderItem = Number(tooltipBodyItem.width) > 0;
                if (shouldRenderItem) {
                    // @ts-ignore FIXME: strict migration - Type 'string | undefined' is not assignable to type 'string' — ITrafficShareBarProps.backgroundColor is optional (see TODO in StyledTrafficShare), Legend requires string
                    const legendColor: string = tooltipBodyItem.backgroundColor;
                    // @ts-ignore FIXME: strict migration - Type 'string | undefined' is not assignable to type 'string' — ITrafficShareBarProps.name is optional (see TODO in StyledTrafficShare), Legend requires string
                    const legendName: string = tooltipBodyItem.name;
                    return (
                        <TooltipBodyItemContainer>
                            <Legend
                                isMain={false}
                                color={legendColor}
                                name={legendName}
                            />
                            <SiteShare>
                                {tooltipBodyItem.tooltipText ? tooltipBodyItem.tooltipText : tooltipBodyItem.text}
                            </SiteShare>
                        </TooltipBodyItemContainer>
                    );
                }
            })}
        </>
    );
};

interface ITrafficShareTooltipContentProps {
    trafficShareProps: ITrafficShareBarProps[];
    title?: string;
    subTitles?: string[];
}

export const TrafficShareTooltipContent = ({
    title,
    trafficShareProps,
    subTitles,
}: ITrafficShareTooltipContentProps) => {
    return (
        <TooltipContainer>
            <RenderTooltipTitleIfNeeded title={title} />
            <RenderSubTitleIfNeeded subTitles={subTitles} />
            <RenderTooltipBody tooltipBodyItems={trafficShareProps} />
        </TooltipContainer>
    );
};

TrafficShareTooltipContent.displayName = "TrafficShareTooltipContent";
